/** @jsxImportSource @emotion/react */
import { faDownToLine } from "@fortawesome/pro-regular-svg-icons";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import useConfig from "../../../../actions/Tenants/config/configHook";
import { useAddLayerAllocationMutation } from "../../../../hooks/mutations";
import { useRouteLayer } from "../../../../hooks/useCurrentEntities";
import { RadioButtons } from "../../../Forms/RadioButton";
import SingleSelect from "../../../Forms/SingleSelect";
import { Button } from "../../../Helper/Button";

export default function AllocateLayerModal() {
    const config = useConfig();
    const layer = useRouteLayer();
    const locations = config.facility_locations || [];

    const [isOpen, setModal] = useState(false);
    const addLayerAllocationMutation = useAddLayerAllocationMutation();
    const queryClient = useQueryClient();

    // * Transform locations for both RadioButtons and SingleSelect (both support label and value)
    const locationOptions = locations.map((location) => ({
        ...location,
        label: location.label || location.location_id,
        value: location.location_id
    }));


    const current_location_id = layer.latest_location?.location_id;

    const allocateLayerToLocation = (location_id) => {
        const location = config.get_facility_location(location_id);

        if (!location) {
            return;
        }

        const { stage, facility } = location;

        if (location_id === layer.latest_location?.location_id || !location_id) {
            return;
        }

        // TODO: just store location id, when datafactory + analytical db is ready
        addLayerAllocationMutation.mutateAsync({ tenantId: layer.tenant_id, layerId: layer.id, stage, locationId: location_id, includeChildren: true, facility })
            .then(() => {
                queryClient.invalidateQueries({ queryKey: ["layer", layer.tenant_id, layer.id] });
            });
        setModal(false);
    };
    const layer_type = config.get_layer_config(layer);

    return <>
        {layer_type.show_allocate_button && (
            <Button
                color="primary"
                outline
                onClick={() => setModal(true)}
                icon={faDownToLine}
            >
                Allocate
            </Button>
        )}

        <Modal key={1} isOpen={isOpen} size="md">
            <ModalHeader>Allocation</ModalHeader>

            <ModalBody>
                {locationOptions.length < 7 ? (
                    <RadioButtons
                        name="location_id"
                        color="secondary"
                        current={current_location_id}
                        options={locationOptions}
                        onChange={(_, value) => allocateLayerToLocation(value)}
                    />
                ) : (
                    <SingleSelect
                        field="location_id"
                        options={locationOptions}
                        post_value={current_location_id}
                        setValue={(field, value) => allocateLayerToLocation(value)}
                        label={false}
                    />
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="light" onClick={() => setModal(false)}>Cancel</Button>
            </ModalFooter>
        </Modal>
    </>;
}
